module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-label-item"
  }, [_c('el-checkbox-button', _vm._b({}, 'el-checkbox-button', _vm.$attrs, false), [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31d8ae71"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/label/rtLabelItem.vue
// module id = 1485
// module chunks = 124